import * as React from "react";
import { NoRxSelectionColumnContainer } from "../../../../../../../../NoRxSelectionColumn/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/components/NoRxSelectionColumn/NoRxSelectionColumnContainer.js";
const CLOneColPrescriptionSelector = () => /* @__PURE__ */ React.createElement("div", { className: "cl-one-col-prescription-selector" }, /* @__PURE__ */ React.createElement(NoRxSelectionColumnContainer, { "data-t": "prescription-both-eyes", eyeSideId: "both" }));
export {
  CLOneColPrescriptionSelector
};
//# sourceMappingURL=CLOneColPrescriptionSelector.js.map
